import isEmpty from "lodash/fp/isEmpty";
import cloneDeep from "lodash/fp/cloneDeep";

class Controller {
  constructor(Lists, Events) {
    "ngInject";

    this.Events = Events;
    this.Lists = Lists.all;
    this.defaultWeekDays = [...this.Lists.weekDays];
  }

  $onInit() {
    // For binding the weekdays values directly
    const initializedWeekdays =
      this.selectedDays && this.selectedDays.length > 0
        ? [
            ...this.Lists.weekDays.map((day) => ({
              ...day,
              isSelected: this.selectedDays.includes(day.value),
            })),
          ]
        : this.defaultWeekDays;
    const weekDaysClone = cloneDeep(initializedWeekdays);

    // If Empty
    if (isEmpty(this.weekDaysArray)) {
      this.isDisabled = false;
      this.isNewInstance = true;
      this.weekDays = weekDaysClone;
      this.weekDaysArray = [...this.weekDays];
    } else if (this.isDisabled) {
      this.weekDays = weekDaysClone.map((day) => {
        day.isSelected = this.weekDaysArray.includes(day.value);
        return day;
      });
    } else {
      this.isDisabled = false;
      this.isNewInstance = true;
      this.weekDays = cloneDeep(this.selectedDays);
    }

    this.selectWeekDay = (index, day) => {
      if (this.isDisabled === false) {
        this.weekDays[index].isSelected = !day.isSelected;
        this.selectedDays = this.weekDays
          .filter((day) => day.isSelected)
          .map((d) => d.value);
      }
      this.weekDaysArray = this.weekDays;
    };

    this.getDayStyle = (day) => {
      return {
        selected: day.isSelected,
        editable: !this.isDisabled,
        "--small": this.size === "small",
      };
    };

    this.edit = () => {
      this.isDisabled = false;
    };
  }
  save() {
    this.isDisabled = true;
    const options = {};
    options.key = this.name;
    options.value = this.selectedDays;
    options.methodName = this.resourceMethodName;

    this.Events.emit(this.eventName, options);
  }
}

export default Controller;



// WEBPACK FOOTER //
// ./src/components/scheduleWeekdays/scheduleWeekdays.controller.js